import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
    selector: 'note-modal',
    templateUrl: './note-modal.component.html'
})
export class NoteModalComponent implements OnInit {
    public detailsId: number;

    constructor(
        public dialogRef: MatDialogRef<NoteModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: number
    ) {
        this.detailsId = data;
    }

    ngOnInit() {}
}
